/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Field, FieldWrapper, SelectArrow } from '../../../styles';

const Options = ({ options, defaultOption }) => {
  return (
    <>
      <option value=''>{defaultOption}</option>
      {options &&
        options.length > 0 &&
        options.map(option => (
          <option key={option.id} value={option.id}>
            {option.name || option.description}
          </option>
        ))}
    </>
  );
};

const SelectField = ({ name, options = [], disabled, renderError = () => {}, ...props }) => {
  const { register, errors } = useFormContext();
  const { t } = useTranslation();
  const label = t(`publisher.step4.module2.field.${name}.label`);
  const defaultOption = t(`publisher.step4.module2.field.${name}.placeholder`);

  return (
    <FieldWrapper disabled={disabled}>
      <label htmlFor={name}>{label}</label>
      <Field
        as='select'
        ref={register}
        error={!!errors[name]}
        name={name}
        id={name}
        data-checkout={name}
        required
        disabled={disabled}
        {...props}
      >
        <Options options={options} defaultOption={defaultOption} />
      </Field>
      <SelectArrow disabled={disabled} />
      {renderError({ name, errors })}
    </FieldWrapper>
  );
};

export { SelectField };
